import { render, staticRenderFns } from "./NotificationsHistory.vue?vue&type=template&id=62fd6f9c&"
import script from "./NotificationsHistory.vue?vue&type=script&lang=js&"
export * from "./NotificationsHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports